import type {
  CostLike,
  PriceContext,
  ProjectLikeWithPricingFields,
} from './types.ts'

export const getPriceValue = (
  context: PriceContext,
  { cost, costPlusMargin }: CostLike
) => {
  if (context === 'agency') {
    return cost
  }

  if (context === 'brand') {
    return costPlusMargin
  }
}

export const getBidValue = (
  context: PriceContext,
  projectLike: ProjectLikeWithPricingFields
) => {
  const acceptedBid = projectLike.bids?.find((bid) => bid.status === 'accepted')

  if (context === 'agency') {
    return acceptedBid ? acceptedBid.amount : projectLike.cost
  }

  if (context === 'brand') {
    return acceptedBid
      ? acceptedBid.amountPlusMargin
      : projectLike.costPlusMargin
  }
}
